/* tslint:disable */
/* eslint-disable */
/**
 * Walnut Server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 4.148.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { SettingsSchemaAxeDevtoolsWatcherImpactsFromJSON, SettingsSchemaAxeDevtoolsWatcherImpactsToJSON, } from './SettingsSchemaAxeDevtoolsWatcherImpacts';
import { SettingsSchemaAxeDevtoolsWatcherIssueThresholdFromJSON, SettingsSchemaAxeDevtoolsWatcherIssueThresholdToJSON, } from './SettingsSchemaAxeDevtoolsWatcherIssueThreshold';
import { SettingsSchemaAxeDevtoolsWatcherOnlyNewIssuesFromJSON, SettingsSchemaAxeDevtoolsWatcherOnlyNewIssuesToJSON, } from './SettingsSchemaAxeDevtoolsWatcherOnlyNewIssues';
/**
 * Check if a given object implements the PartialSettingsSchemaAxeDevtoolsWatcher interface.
 */
export function instanceOfPartialSettingsSchemaAxeDevtoolsWatcher(value) {
    let isInstance = true;
    return isInstance;
}
export function PartialSettingsSchemaAxeDevtoolsWatcherFromJSON(json) {
    return PartialSettingsSchemaAxeDevtoolsWatcherFromJSONTyped(json, false);
}
export function PartialSettingsSchemaAxeDevtoolsWatcherFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'onlyNewIssues': !exists(json, 'onlyNewIssues') ? undefined : SettingsSchemaAxeDevtoolsWatcherOnlyNewIssuesFromJSON(json['onlyNewIssues']),
        'impacts': !exists(json, 'impacts') ? undefined : SettingsSchemaAxeDevtoolsWatcherImpactsFromJSON(json['impacts']),
        'issueThreshold': !exists(json, 'issueThreshold') ? undefined : SettingsSchemaAxeDevtoolsWatcherIssueThresholdFromJSON(json['issueThreshold']),
        'sessionCloseTimeout': !exists(json, 'sessionCloseTimeout') ? undefined : SettingsSchemaAxeDevtoolsWatcherIssueThresholdFromJSON(json['sessionCloseTimeout']),
    };
}
export function PartialSettingsSchemaAxeDevtoolsWatcherToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'onlyNewIssues': SettingsSchemaAxeDevtoolsWatcherOnlyNewIssuesToJSON(value.onlyNewIssues),
        'impacts': SettingsSchemaAxeDevtoolsWatcherImpactsToJSON(value.impacts),
        'issueThreshold': SettingsSchemaAxeDevtoolsWatcherIssueThresholdToJSON(value.issueThreshold),
        'sessionCloseTimeout': SettingsSchemaAxeDevtoolsWatcherIssueThresholdToJSON(value.sessionCloseTimeout),
    };
}
